import * as angular from 'angular';

class CampaignActiveDate {
    activeDate: string;

    private startDate: Date;
    private endDate: Date;
    private wrapping: boolean;

    constructor(private $filter: ng.IFilterService) {
    }

    $onChanges(changes: any) {
        if (!this.startDate && !this.endDate) { // noDates
            this.activeDate = 'Runs permanently';
        } else if (!this.endDate && this.startDate) { // onlyStart
            this.activeDate = `Runs from ${this.$filter('date')(this.startDate, 'd MMM yyyy')}`;
        } else if (!this.startDate && this.endDate) { // onlyEnd
            this.activeDate = `Runs till ${this.$filter('date')(this.endDate, 'd MMM yyyy')}`;
        } else if (this.endDate && this.startDate) { // allDates
            this.activeDate = `Runs from ${this.$filter('date')(this.startDate, 'd MMM yyyy')}
            ${this.wrapping ? '<br />' : ' '}till ${this.$filter('date')(this.endDate, 'd MMM yyyy')}`;
        } else {
            this.activeDate = null;
        }
    }
}

angular
    .module('app.retailes.common')
    .component('campaignActiveDate', {
        template: require('./campaign-active-date.html'),
        controller: CampaignActiveDate,
        controllerAs: 'vm',
        bindings: {
            startDate: '<',
            endDate: '<',
            wrapping: '<'
        }
    });



// WEBPACK FOOTER //
// ./src/app.retailer.common/components/campaign-active-date/campaign-active-date.component.ts